import GallerySupportingAsset from "./GallerySupportingAsset";

export default GallerySupportingAsset;
